import { PropsWithRef } from 'react';

interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function CheckmarkIcon(props: PropsWithRef<Props>) {
  const { size = 18, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m1 9 5.84 5.45L17.13 3.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
